import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AREAS } from "@/lib/content";
import { ArrowUpRight } from "lucide-react";

export default function ServicesGrid({ compact = false }) {
    return (
        <section
            data-testid="services-grid"
            className="relative py-24 bg-[#0A0A0B]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
                    <div className="lg:col-span-5">
                        <p className="overline">Rättsområden</p>
                        <h2 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F4F5]">
                            Bred kompetens,
                            <br />
                            <span className="italic text-[#C4A977]">
                                djup
                            </span>{" "}
                            specialisering.
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
                        <p className="text-[#A1A1AA] text-base lg:text-lg leading-relaxed">
                            Vi arbetar inom tolv rättsområden — från affärsjuridik
                            och fastighetsrätt till arvsrätt, migrationsrätt och
                            brottmål. Gemensamt för samtliga är ett personligt
                            engagemang i varje enskilt uppdrag.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {AREAS.map((a, i) => {
                        const Icon = a.icon;
                        return (
                            <motion.div
                                key={a.id}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.7, delay: Math.min(i * 0.05, 0.4) }}
                            >
                                <Link
                                    to={`/tjanster#${a.id}`}
                                    data-testid={`service-card-${a.id}`}
                                    className="group block h-full bg-[#111113] border border-white/5 hover:border-[#C4A977]/40 p-8 rounded-sm transition-all duration-500 relative overflow-hidden"
                                >
                                    <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C4A977]/0 to-transparent group-hover:via-[#C4A977]/60 transition-all duration-700" />
                                    <div className="flex items-start justify-between">
                                        <div className="w-12 h-12 border border-white/10 group-hover:border-[#C4A977]/50 grid place-items-center transition-colors duration-500">
                                            <Icon
                                                size={20}
                                                className="text-[#C4A977]"
                                            />
                                        </div>
                                        <ArrowUpRight
                                            size={18}
                                            className="text-[#A1A1AA] group-hover:text-[#C4A977] group-hover:rotate-45 transition-all duration-500"
                                        />
                                    </div>
                                    <h3 className="mt-8 font-serif text-2xl lg:text-3xl text-[#F4F4F5] group-hover:text-[#C4A977] transition-colors duration-500">
                                        {a.title}
                                    </h3>
                                    <p className="mt-3 text-[#A1A1AA] text-sm leading-relaxed">
                                        {a.short}
                                    </p>
                                    {!compact && (
                                        <ul className="mt-6 space-y-2">
                                            {a.bullets.slice(0, 3).map((b) => (
                                                <li
                                                    key={b}
                                                    className="text-xs text-[#A1A1AA] flex items-center gap-2"
                                                >
                                                    <span className="w-1 h-1 bg-[#C4A977] rounded-full" />
                                                    {b}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
